import { render, staticRenderFns } from "./VPostitMenuItem.vue?vue&type=template&id=66c7235d&"
import script from "./VPostitMenuItem.vue?vue&type=script&lang=js&"
export * from "./VPostitMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports